import React, { FC } from 'react';
import { SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import { useTranslation } from '../../utils/useTranslation';
import { Drawer, DrawerContent } from '../feedback/Drawer';
import { IconLogo } from '../icon/IconLogo';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { TransitionSlideUp } from '../transition/TransitionSlideUp';
import { Typography } from '../typography/Typography';

const DOWNLOAD_LINK = 'https://clck.ru/3CBSWm';

const IconLogoBox = styled(Box).attrs({
    position: 'absolute',
    top: '-30px',
    left: '24px',
    border: '5px solid var(--background-primary)',
    borderRadius: '28px',
})``;

interface AppDiscoveryMobileProps {
    onClose: () => void;
}

export const AppDiscveryMobile: FC<AppDiscoveryMobileProps> = ({ onClose }) => {
    const t = useTranslation();
    const onDownloadClick = () => window.open(DOWNLOAD_LINK, '_blank');

    return (
        <SwitchTransition>
            <TransitionSlideUp>
                <Drawer
                    onClose={onClose}
                    borderTopLeftRadius={0}
                    borderTopRightRadius={0}
                    overflow="visible"
                >
                    <DrawerContent p={3} pt={8} overflowY="visible">
                        <IconLogoBox>
                            <IconLogo fontSize="72px" />
                        </IconLogoBox>
                        <Typography variant="title2" weight="bold">
                            {t('В приложении удобнее')}
                        </Typography>
                        <Typography variant="body" weight="regular" pt={1}>
                            {t('Продолжите в приложении, чтобы получить все возможности')}
                        </Typography>
                        <Box pt={2.5} width="100%">
                            <Button
                                variant="filled"
                                size="l"
                                width="100%"
                                onClick={onDownloadClick}
                            >
                                {t('СКАЧАТЬ ПРИЛОЖЕНИЕ')}
                            </Button>
                        </Box>
                        <Box pt={1} width="100%">
                            <Button
                                variant="filled"
                                color="secondary"
                                size="l"
                                width="100%"
                                onClick={onClose}
                            >
                                {t('ПРОДОЛЖИТЬ В БРАУЗЕРЕ')}
                            </Button>
                        </Box>
                    </DrawerContent>
                </Drawer>
            </TransitionSlideUp>
        </SwitchTransition>
    );
};
